export default "__VITE_ASSET__047cdf41__"